import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
} from '@angular/core';
import { tap } from 'rxjs/operators';
import { MenuDrawerSectionContentComponent } from './menu-drawer-section-content/menu-drawer-section-content.component';
import { MobileMainSectionsLeftMenuComponent } from './mobile-main-sections-left-menu/mobile-main-sections-left-menu.component';
import { SideDrawerDirective } from '../../directives/sideDrawer.directive';
import { MenuTool } from '../../interfaces/MenuTool.interface';
import { NavigationItem } from '../../interfaces/navigationList.interface';
import {
  HomeButtonConfig,
  Profile,
} from '../../interfaces/PageContainerConfiguration.interface';
import { PageContainerService } from '../../services/page-container.service';

@Component({
  selector: 'z-side-menu-drawer',
  standalone: true,
  imports: [
    CommonModule,
    SideDrawerDirective,
    MobileMainSectionsLeftMenuComponent,
    MenuDrawerSectionContentComponent,
  ],
  templateUrl: './side-menu-drawer.component.html',
  styleUrls: ['./side-menu-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('drawerState', [
      state(
        'open',
        style({
          width: '100%',
          opacity: 1,
        }),
      ),
      state(
        'closed',
        style({
          width: '0%',
          opacity: 0,
          display: 'none',
        }),
      ),
      transition('closed => open', [animate('350ms linear')]),
      transition('open => closed', [animate('350ms linear')]),
    ]),
    trigger('drawerContentState', [
      state(
        'open',
        style({
          width: '100%',
          opacity: 1,
        }),
      ),
      state(
        'closed',
        style({
          width: '0%',
          opacity: 0,
        }),
      ),
      transition('closed => open', [animate('350ms linear')]),
      transition('open => closed', [animate('350ms linear')]),
    ]),
  ],
})
export class SideMenuDrawerComponent {
  navigationList = input.required<NavigationItem[]>();
  dashboardRoutes = input.required<NavigationItem[]>();
  settingsRoutes = input.required<NavigationItem>();
  homeButton = input.required<HomeButtonConfig>();
  tools = input.required<MenuTool[]>();
  profile = input.required<Profile>();
  settingURL = input<string>();
  maxWidth = input.required<string>();
  hideTools = input<boolean>(false);

  isOpen = signal(false);
  showContent = signal(false);
  navigationItem = signal<NavigationItem | null>(null);
  toolsContent = signal<MenuTool[] | null>(null);

  expandMenuDrawer$ = this.pageContainerService.expandMenuDrawer$.pipe(
    tap(x => {
      this.isOpen.set(x);
      if (!x) {
        this.showContent.set(false);
        this.navigationItem.set(null);
      }
    }),
  );

  constructor(readonly pageContainerService: PageContainerService) {}

  selectionItem(item: NavigationItem) {
    this.toolsContent.set(null);
    this.navigationItem.set(item);
    this.showContent.set(true);
  }

  hideContent() {
    this.showContent.set(false);
    this.navigationItem.set(null);
    this.toolsContent.set(null);
  }

  openTools() {
    this.navigationItem.set(null);
    this.toolsContent.set(this.tools());
    this.showContent.set(true);
  }
}
